export default __webpack_public_path__ + "static/media/Component202.5df635ad.png";